import React, { Fragment } from 'react'
import { HrefLangHeadProps } from './HrefLangHead.d'

const HrefLangHead = ({
  canonical,
  currentLanguage,
  defaultSiteUrl,
  localizedEntries,
  slug
}: HrefLangHeadProps) => {
  const getSlug = (slug: string) => {
    return !slug || slug === '/on-the-line'
      ? ''
      : slug.startsWith('/')
      ? slug
      : `/${slug}`
  }

  return (
    <>
      <link
        href={canonical}
        rel='alternate'
        hrefLang={currentLanguage.toLowerCase()}
      />
      {currentLanguage === 'en-US' && (
        <link
          href={`${defaultSiteUrl}${getSlug(slug)}`}
          rel='alternate'
          hrefLang='x-default'
        />
      )}
      {localizedEntries.map((entry: any) => {
        if (entry.language) {
          let siteUrl: string | string[] = defaultSiteUrl.split('/')
          let regionString =
            entry?.language && entry.language !== 'en-US'
              ? `${entry.language.toLowerCase().split('-')[1]}`
              : ''
          if (regionString === 'gb') {
            regionString = 'uk'
          }
          if (entry?.language && entry.language !== 'en-US') {
            siteUrl.splice(3, 0, regionString)
          }
          siteUrl = siteUrl.join('/')
          return (
            <Fragment key={entry.language}>
              <link
                href={`${siteUrl}${getSlug(`/${entry.slug}`)}`}
                rel='alternate'
                hrefLang={entry.language.toLowerCase()}
              />
              {entry.language === 'en-US' && (
                <link
                  href={`${siteUrl}${getSlug(`/${entry.slug}`)}`}
                  rel='alternate'
                  hrefLang='x-default'
                />
              )}
            </Fragment>
          )
        } else {
          return <></>
        }
      })}
    </>
  )
}

export default HrefLangHead
